import Sites from '@toasttab/shared/src/data/Sites.json'
import { ActivePages } from '@toasttab/shared/src/components/organisms/Header/Banner/GlobalBanner.d'
import {
  EntryPathSchema,
  PackageSchema,
  SiteSchema
} from '@toasttab/shared/src/components/organisms/Header/RegionBanner.d'

export const getIsActivePage = (activePages: ActivePages) => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname
    // Remove language codes from path
    const pathArr = path
      .split('/')
      .filter((p) => !['ca', 'ie', 'uk', 'au'].includes(p))
    // Re-join the string and remove leading and trailing slashes
    const pathNoLang = pathArr.join('/').replace(/^\/|\/$/g, '')

    if (activePages?.excludePaths?.includes(pathNoLang)) {
      return false
    } else if (activePages.all) {
      return true
    } else if (activePages.home && pathNoLang === '') {
      return true
    } else if (activePages.customPaths?.includes(pathNoLang)) {
      return true
    } else {
      const activePageTypes = []
      for (const key in activePages) {
        const value = activePages[key as keyof ActivePages]
        if (typeof value === 'boolean' && value) {
          // Replace underscores with hyphens because graphql doesn't support hyphens in queries
          // This allows us to use values like `restaurant_pos: true` and have it match the site URL without adding specific cases to this function
          const pageType = key.replace(/_/g, '-')
          activePageTypes.push(pageType)
        }
      }
      if (activePageTypes.includes(pathArr[1])) {
        return true
      }
    }
    return false
  }
}

export const getIsActiveDate = (startDate: string, endDate: string) => {
  const currentDate = new Date()
  return currentDate >= new Date(startDate) && currentDate <= new Date(endDate)
}

export const getRegion = (region: string | undefined) => {
  if (!region) {
    return 'US'
  } else {
    // Check if the region is 'UK' and return 'GB' if it matches
    if (region.toUpperCase() === 'UK') {
      return 'GB'
    }
    // Check if the region matches any site and return the region in uppercase
    return Sites.sites
      .filter((site) => site.defaultRegion)
      .find((site) => site.craftSite === region.toUpperCase())
      ? region.toUpperCase()
      : 'US'
  }
}

export const updateRegionBannerState = (
  activeBannerCountryCode: string,
  preRegion: string,
  country: string
): boolean => {
  let state = false
  if (
    (preRegion && activeBannerCountryCode !== preRegion) ||
    (!preRegion && activeBannerCountryCode !== country) ||
    (!preRegion && !country)
  ) {
    state = true
  }

  return state
}

export const formatRegionBannerUrl = (
  site: SiteSchema,
  packageObj: PackageSchema,
  entryPath: EntryPathSchema
): string => {
  let url = `${site.url}${packageObj?.path}${entryPath.uri}`

  // for OTL, set the non-US OTL Homepage
  if (packageObj?.path === '/blog/on-the-line' && site.url !== '') {
    url = `${site.url}${packageObj?.path}`
  }

  return url.replace(/\/+$/, '')
}
